import React from 'react';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import NeuroMessage from './NeuroMessage';

const Tooltip = (props) => {
  const {
    attributes,
    messageId,
    content,
    iconRender = <i className="fa fa-info-circle" />,
    className,
    type,
  } = props;

  const classes = classnames('toolTip', className);

  const anchorProps = attributes?.anchor;
  const tooltipProps = attributes?.tooltip;

  return (
    <>
      <span
        aria-describedby={messageId}
        className={classes}
        data-tip="custom show"
        data-event="touchstart click focus mouseenter"
        data-event-off="blur mouseleave"
        data-type={type}
        data-for={messageId}
        tabIndex="0"
        {...anchorProps}
      >
        {iconRender}
        { type === 'error' &&
          <span className="sr-only" role="alert">
            {content || <NeuroMessage id={messageId} />}
          </span>
        }
      </span>
      <ReactTooltip id={messageId} effect="solid" role={type === 'error' ? 'alert' : 'tooltip'} tagName="p" globalEventOff="touchstart" {...tooltipProps}>
        {content || <NeuroMessage id={messageId} />}
      </ReactTooltip>
    </>
  );
};
Tooltip.propTypes = {
  attributes: PropTypes.object,
  messageId: PropTypes.string,
  content: PropTypes.any,
  iconRender: PropTypes.any,
  className: PropTypes.string,
  type: PropTypes.string,
};

const QuestionAnswersToolTip = ({ questionKey, answerKey, attributes }) => {
  const messageKey = `${questionKey}.${answerKey}.tooltip`;
  const tooltipProps = attributes?.tooltipProps || {};
  return (
    <NeuroMessage id={messageKey} shouldHideIfNotFound={true}>
      { () => <Tooltip className="answer__tooltip" messageId={messageKey} attributes={tooltipProps}/> }
    </NeuroMessage>
  );
};
QuestionAnswersToolTip.propTypes = {
  questionKey: PropTypes.string.isRequired,
  answerKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  attributes: PropTypes.object
};

export default Tooltip;
export { QuestionAnswersToolTip };
